import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { IEntityResolver } from '@kpd/framework-ngx';
import { Permissionset } from 'app/shared/models/permissionset';
import { PermissionsetService } from 'app/shared/services/permissionset.service';
import { PermissionsetKey } from 'app/shared/models/keys/permissionset-key';

@Injectable()
export class PermissionsetEntityResolver implements IEntityResolver<Permissionset> {
  constructor(private permissionSetService: PermissionsetService) {}

  resolve(params: { permissionSetId: string; applicationId: string; type?: string }): Observable<Permissionset> {
    if (params.permissionSetId === '0') {
      return of(new Permissionset());
    }
    const key = PermissionsetKey.composeKeyByRouteParams(params);
    return this.permissionSetService.getById(key as PermissionsetKey);
  }
}
